import ColorFilter from 'core/display/ColorFilter'
import { resize } from 'services/ResizeService'
import { signal } from 'services/SignalsService'
import { log } from 'utils/Logger'

import Sprite from './Sprite'

export default class VideoSprite extends Sprite.from{
  constructor(data) {
    super(data.videoPath)

    this.width = data.width * data.scale
    this.height = data.height * data.scale

    this.x = data.posX
    this.y = data.posY

    if(this.texture){
      this.texture.baseTexture.resource.autoPlay = false
      this.controller = this.texture.baseTexture.resource.source
      this.controller.loop = false
      this.controller.muted = true
      let filter = new ColorFilter(data)
      filter.blendMode = PIXI.BLEND_MODES.NORMAL_NPM

      this.filters = [filter]

      this.visible = false

      let playPromise = this.controller.play()

      signal.on(`${data.signalOn}`, () => {
        this.visible = true
        this.controller.currentTime = 0
        if (playPromise !== undefined) {
          playPromise.then(() => {
            this.controller.currentTime = 0
            this.controller.play()
          })
            .catch((error) => {
              log(error)
            })
        }
        resize()
      })
      signal.on(`${data.signalOff}`, () => {
        this.visible = false
        this.controller.currentTime = 0
        if (playPromise !== undefined) {
          playPromise.then(() => {
            this.controller.pause()
          })
            .catch((error) => {
              log(error)
            })
        }
      })
    }
  }

  set loop(loop){
    this.controller.loop = loop
  }

  get loop(){
    return  this.controller.loop
  }
}
